import { faEye, faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "components";
import Pagination from "components/pagination";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "services/api";

export const CorperatesUserList = () => {
  const [corperators, setCorperators] = useState([]);
  const [currentPage, SetCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const fetchCorperate = async (page = 1, query = "") => {
    try {
      const response = await api.get(
        `/corporate-entities?page=${page}&search=${query}`
      );
      setCorperators(response?.data?.data?.data);
      SetCurrentPage(page);
      console.log("fetchCorperate:", response.data);
    } catch (error) {
      console.log(" fetchCorperate Error:", error);
    }
  };

  const handleSearch = () => {
    const query = search.trim(); // Trim whitespace from the input
    fetchCorperate(1, query); // Pass an empty string if the input is empty
  };

  useEffect(() => {
    fetchCorperate(1, search);
  }, []);

  return (
    <>
      <Container>
        <div class="content-wrapper">
          <div
            class="container-xxl flex-grow-1 container-p-y"
            style={{ height: "43px" }}
          >
            <h4 className="card-header">Corporates</h4>
            <div className="d-flex justify-content-end">
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)} // Update the search state.
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch(); // Trigger search on Enter
                }}
                placeholder="search"
                className=" me-3 mb-4 "
                style={{
                  outline: "none",
                  boxShadow: "none",
                  border: "1px solid transparent",
                }}
              />
              <button
                className="btn btn-primary me-2 mb-4"
                onClick={handleSearch}
              >
                Search
              </button>
              <button
                className="btn btn-primary me-5 mb-4"
                onClick={() => navigate("/addCorporates")}
              >
                Add Corporate
              </button>
            </div>
            <div class="card-datatable table-responsive">
              <table class="invoice-list-table table border-top dataTable no-footer dtr-column mb-5">
                <thead>
                  <tr>
                    <th>Sno</th>
                    <th>Corporate Name</th>
                    <th>Contact Email</th>
                    <th>Contact Phone</th>
                    <th>Industry</th>
                    <th>Plan Name</th>
                    <th>Plan Price</th>
                    <th>Plan Status</th>
                    <th>Membership Type</th>
                    <th>Created On</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {corperators?.map((res, index) => {
                    const serialNumber =
                      (currentPage - 1) * corperators?.pagination?.per_page +
                      (index + 1);
                    return (
                      <tr key={res.id}>
                        <td>{index + 1}</td>
                        <td>{res.name}</td>
                        <td>{res.contact_email}</td>
                        <td>{res.contact_phone}</td>
                        <td>{res.industry?.name || "N/A"}</td>
                        <td>{res.plan_name}</td>
                        <td>₹{res.plan_price}</td>
                        <td>
                          <span
                            className={`badge ${
                              res.plan_status === "Active"
                                ? "bg-success"
                                : "bg-danger"
                            }`}
                          >
                            {res.plan_status}
                          </span>
                        </td>
                        <td>{res.membership_type}</td>
                        <td>{moment(res.created_at).format("DD-MM-YYYY")}</td>
                        <td>
                          <FontAwesomeIcon
                            icon={faEye}
                            onClick={() =>
                              navigate(`/corporatesDetails/${res?.id}`)
                            }
                            className="me-3"
                            style={{ cursor: "pointer" }}
                          />
                          <FontAwesomeIcon
                            icon={faEdit}
                            onClick={() =>
                              navigate(`/addCorporates/${res?.id}`)
                            }
                            className="me-3"
                            style={{ cursor: "pointer" }}
                          />
                          <FontAwesomeIcon
                            icon={faTrash}
                            className="me-3"
                            style={{ cursor: "pointer" }}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {corperators?.pagination?.total > 0 && (
                <Pagination
                  totalPages={corperators?.pagination?.total}
                  perPage={corperators?.pagination?.per_page}
                  handleFunction={fetchCorperate}
                />
              )}
            </div>
          </div>

          <div class="content-backdrop fade"></div>
        </div>
      </Container>
    </>
  );
};
